"use strict";

var _defineProperty = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _exports$ZORA_MEDIA_C;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZORA_MEDIA_CONTRACT_BY_NETWORK = void 0;

var networks_1 = require("./networks");

exports.ZORA_MEDIA_CONTRACT_BY_NETWORK = (_exports$ZORA_MEDIA_C = {}, _defineProperty(_exports$ZORA_MEDIA_C, networks_1.Networks.MAINNET, '0xabEFBc9fD2F806065b4f3C237d4b59D9A97Bcac7'), _defineProperty(_exports$ZORA_MEDIA_C, networks_1.Networks.RINKEBY, '0x7C2668BD0D3c050703CEcC956C11Bd520c26f7d4'), _exports$ZORA_MEDIA_C);